import { FC, memo, useCallback } from 'react'

import {
    AccommodationContainer,
    Container,
    FooterContainer,
    ImageContainer,
    InnerContainer,
    NextImageContainer,
    RegionTitleContainer,
    SeoHref,
} from './styles'
import { useTranslation } from '../../../../hooks/locale'
import NextImage from '../../../common/next-image'
import { preventDefaultHandler } from '../../../utils'
import { PopularDestinationTransport } from '../../../../transports/region-landing-page-transport'
import AnalyticsService from '../../../../services/analytics-service'
import { landingPageEventCategories } from '../../../../services/analytics-service/categories'

const BestDestinationCard: FC<PopularDestinationTransport> = ({ url, title, imageUrl, count, noCrawl }) => {
    const { t } = useTranslation()

    const handleClick = useCallback(() => {
        AnalyticsService.trackClickEvent(landingPageEventCategories.bestDestinationsSection.CARD_CLICK, url)
        window.open(url, '_blank')
    }, [url])

    return (
        <Container onClick={handleClick}>
            <InnerContainer>
                <ImageContainer>
                    <NextImage
                        containerComponent={NextImageContainer}
                        src={imageUrl}
                        alt={title}
                        sizes="(max-width: 767px) 5.625rem, 20rem"
                        width={400}
                        height={300}
                    />
                </ImageContainer>
                <FooterContainer>
                    <RegionTitleContainer>
                        <SeoHref
                            href={url}
                            noCrawl={noCrawl}
                            target={'_blank'}
                            onClick={preventDefaultHandler}
                            title={title}
                            autoRedirect={false}
                        >
                            {title}
                        </SeoHref>
                    </RegionTitleContainer>
                    <AccommodationContainer>{`${count} ${
                        count === 1 ? t('accommodation') : t('accommodations')
                    }`}</AccommodationContainer>
                </FooterContainer>
            </InnerContainer>
        </Container>
    )
}

export default memo(BestDestinationCard)
